import { createUnorderedVerticalList } from '@vfde-brix/ws10/unordered-vertical-list';
import {
    createComponentById,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';

/**
 * Creates a WS10 Unordered Vertical List component.
 */
export const mountVerticalList = (id: HtmlId) =>
    createComponentById(createUnorderedVerticalList, id, NO_PATTERN_BUSINESS_LOGIC);
